module.exports = __webpack_public_path__ + "public/assets/img/logo2.89201549.png";